export enum EnumTpImp {
    SEM_GERACAO_DANFE = 0,
    DANFE_NORMAL_RETRATO = 1,
    DANFE_NORMAL_PAISAGEM = 2,
    DANFE_SIMPLIFICADO = 3,
    DANFE_NFCE = 4,
    DANFE_NFCE_ELETRONICA = 5,
}